import { useContext, useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import { DonwloadFile } from "./download-file-page";
import { UploadFilePage } from "./upload-file-page";
import { UserProgramContext } from "../../../context/user-program/user-program";

export const FilePage = () => {
  const { role } = useContext(UserProgramContext);
  const [value, setValue] = useState("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    event.preventDefault();
    setValue(newValue);
  };

  return (
    <Box
      sx={{ width: "100%", typography: "body1", mt: "50px", overflowX: "auto" }}
    >
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          {role === "clinic-weight" || role === "clinic-dashboard" ? (
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab label="Vom Mitarbeiter hochgeladene Dokumente" value="1" />
            </TabList>
          ) : (
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab label="Vom Mitarbeiter hochgeladene Dokumente" value="1" />
              <Tab label="Vom Patienten hochgeladene Dokumente" value="2" />
            </TabList>
          )}
        </Box>
        <TabPanel value="1">
          <UploadFilePage />
        </TabPanel>
        <TabPanel value="2">
          <DonwloadFile />
        </TabPanel>
      </TabContext>
    </Box>
  );
};
